import { CounterCustomizationAttributes } from '../_types/customizations.types';

export const DEFAULT_COUNTER_CUSTOMIZATION: CounterCustomizationAttributes = {
  backgroundColor: '#303030',
  counterFontFamily: 'Arial',
  counterFontSize: '72',
  createdAt: '',
  fontColor: '#ffffff',
  inactivityTimer: 0,
  name: 'default-counter-customization',
  nextTokenSoundEnabled: true,
  ownerId: 0,
  ownerType: 'Branch',
  showIdleScreenAfterInactivity: false,
  showCounterNameWithBanner: false,
  showCounterName: true,
  tokenFontFamily: 'Arial',
  tokenFontSize: '200',
  updatedAt: '',
};
